module.exports = __webpack_public_path__ + "img/blue_155.3d3098a4.png";